import * as React from 'react';
import ModalContext from '../ModalContext';
export const FlyoutTrigger = ({ id, children, showCover = true, preventOverflow = false, canCloseOnEsc = true, coverStyles }) => {
    return (React.createElement(ModalContext.Consumer, null, ({ showTarget, hideTarget, modals }) => {
        const open = () => showTarget(null, 'flyout', id, {
            showCover,
            coverStyles,
            preventOverflow,
            canCloseOnEsc
        });
        return children({
            showTarget: open,
            hideTarget,
            isOpen: modals.some(({ modalId }) => modalId === id)
        });
    }));
};
//# sourceMappingURL=FlyoutTrigger.js.map